var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"loading-arrow-overlay"},[_c('div',{staticClass:"loading-arrow-center"},[_c('img',{staticClass:"loading-arrow-img",attrs:{"src":require("./arror.png"),"alt":"loading-arrow","width":"48","height":"48"}}),(_vm.text)?_c('div',{staticClass:"loading-arrow-text"},[_vm._v(_vm._s(_vm.loadingText))]):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }